import * as fromPaymentCredit from '../../../screens/payment-credit/state/payment-credit.selectors';
import * as PaymentCreditAction from '../../../screens/payment-credit/state/payment-credit.actions';
import {
    Component, OnInit, Input, OnDestroy,
    AfterViewInit, ChangeDetectionStrategy,
    ChangeDetectorRef, ViewChild, SimpleChanges, OnChanges
} from '@angular/core';
// Animations

import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { slideInDownAnimation } from 'src/app/app.animation';
import { AngularMaterialService, LGEDataService } from 'src/commons';
import { FormCCService } from 'src/commons/services/formCC.service';
import { PaymentCreditScreenComponent } from 'src/screens/payment-credit/payment-credit.component';

@Component({
    selector: 'payment-credit-table-component',
    templateUrl: 'payment-credit-table-component.html',
    styleUrls: ['payment-credit-table-component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentCreditTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input() isLoading: boolean;
    @Input() data: any[];
    @Input() displayedColumns: any[];

    // public displayedColumns = [];
    // public displayedColumns = ['requestNo', 'formCCName', 'OrgInfo.name', 'effdt', 'statusDescr', 'validateStatusCode'];
    public dataSource: MatTableDataSource<any>;

    constructor(
        private store: Store<fromPaymentCredit.State>,
        private ref: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private formCCService: FormCCService,
        private ams: AngularMaterialService,
        private _dataService: LGEDataService,
        private paymentCreditComponent: PaymentCreditScreenComponent
    ) {
    }

    public ngOnInit() {
        setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.data);
            const datePipe = new DatePipe('en-US');
            // Sorting nested object
            this.dataSource.sortingDataAccessor = (item, property) => {
                switch (property) {
                    case 'OrgInfo.name': return item.OrgInfo.name.toLowerCase();
                    case 'OrgInfo.subsection_501': return isNaN(item.OrgInfo.subsection_501) ? item.OrgInfo.subsection_501 : +item.OrgInfo.subsection_501;
                    case 'FormCCOeBS.validateStatusCode': return item.FormCCOeBS.validateStatusCode.toLowerCase();
                    case 'effdt': return new Date(item.effdt);
                    default: return item[property];
                }
            };
            this.dataSource.filterPredicate = (data, filter: string) => {
                const accumulator = (currentTerm, key) => {
                    switch (key) {
                        case 'OrgInfo':
                            return currentTerm + data.OrgInfo.name + this.getTaxExemptStatus(data.OrgInfo.subsection_501);
                        case 'FormCCLogInfo':
                            return currentTerm + data.FormCCLogInfo.empName
                                + data.FormCCLogInfo.title
                                + data.FormCCLogInfo.comment;
                        case 'effdt':
                            const newDate = datePipe.transform(data.effdt, 'MM-dd-yyyy');
                            return currentTerm + newDate.toString();
                        default:
                            return currentTerm + data[key];
                    }
                    // return key === 'OrgInfo' ? currentTerm + data.OrgInfo.name : currentTerm + data[key];
                };
                const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
                // Transform the filter by converting it to lowercase and removing whitespace.
                const transformedFilter = filter.trim().toLowerCase();
                return dataStr.includes(transformedFilter);
            };
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        });
    }

    public ngOnChanges(changes: SimpleChanges) {
        // console.log(changes);
        if (changes['data'] || changes['displayedColumns']) {
            setTimeout(() => {
                const datePipe = new DatePipe('en-US');
                this.dataSource = new MatTableDataSource(changes['data'].currentValue);
                this.dataSource.sortingDataAccessor = (item, property) => {
                    switch (property) {
                        case 'OrgInfo.name': return item.OrgInfo.name.toLowerCase();
                        case 'OrgInfo.subsection_501': return isNaN(item.OrgInfo.subsection_501) ? item.OrgInfo.subsection_501 : +item.OrgInfo.subsection_501;
                        case 'FormCCOeBS.validateStatusCode': return item.FormCCOeBS.validateStatusCode.toLowerCase();
                        case 'effdt': return new Date(item.effdt);
                        default: return item[property];
                    }
                };
                this.dataSource.filterPredicate = (data, filter: string) => {
                    const accumulator = (currentTerm, key) => {
                        switch (key) {
                            case 'OrgInfo':
                                return currentTerm + data.OrgInfo.name + this.getTaxExemptStatus(data.OrgInfo.subsection_501);
                            case 'FormCCLogInfo':
                                return currentTerm + data.FormCCLogInfo.empName
                                    + data.FormCCLogInfo.title
                                    + data.FormCCLogInfo.comment;
                            case 'effdt':
                                const newDate = datePipe.transform(data.effdt, 'MM-dd-yyyy');
                                return currentTerm + newDate.toString();
                            default:
                                return currentTerm + data[key];
                        }
                        // return key === 'OrgInfo' ? currentTerm + data.OrgInfo.name : currentTerm + data[key];
                    };
                    const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
                    // Transform the filter by converting it to lowercase and removing whitespace.
                    const transformedFilter = filter.trim().toLowerCase();
                    return dataStr.includes(transformedFilter);
                };
                // this.isLoading = changes.isLoading.currentValue;
                this.displayedColumns = changes['displayedColumns'] !== undefined ? changes['displayedColumns'].currentValue : this.displayedColumns;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            });
        }

    }
    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }

    public payAsCreditCard(row) {
        // console.log(row)
        let confirmationData: any = {};
        confirmationData.formccId = row.formccId;
        confirmationData.requestNumber = row.requestNo;
        confirmationData.requestName = row.formCCName;
        confirmationData.confirmationNoCC = '';
        this.ams.showCreditCardConfirmation('Pay As Credit Card', '', confirmationData);
        this.ams.creditCardConfirmation.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(new PaymentCreditAction.ProcessFormCCAsCredit(result));
                // console.log(result);
                // this.ams.showLoader('Saving...');
                // this._dataService.UpdateFormCCForPaymentAsCredit(result)
                //     .then((data) => {
                //         this.ams.closeDialog();
                //         this.store.dispatch(new PaymentCreditAction.LoadPaymentCreditFormCCState());
                //         this.ams.showAlert('Success!', 'Successfully Saved!');
                //         this.ref.markForCheck();
                //     }, error => {
                //         // console.log(error);
                //         this.ams.closeDialog();
                //         this.ams.showAlert('Error!', 'Resource not available!');
                //         this.ref.markForCheck();
                //     });
            }
        });

    }

    public getStatusClass(status): string {
        const possibleStatus = ['Approved', 'Rejected', 'INVALID', 'VALID', 'SUCCESSFUL'];
        return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
    }

    public selectRow(row): void {
        this.formCCService.setIsAdminReadOnly(row.formccId);
        this.router.navigate([`charity-forms/charitable-contribution/${row.formccId}`]);
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
}
